import { inactivityService, translationService } from '../../services';
import { maybeLog } from '../utils';

/**
 * Intended to be triggered when a user visits the webapp. Used to handle
 * some app/state initialization.
 */
export async function startup( { debug } ) {
    maybeLog( debug, 'Starting React application...' );

    // Begin the tracking of the user's activity status. Note that when a user
    // is taking a course or watching a video, you will probably want to stop
    // the service from watching the user's actions temporarily.
    inactivityService.startWatching();

    // TODO: Remove this inactivity notification test.
    inactivityService.on( 'notify', ( _count, duration ) => {
        console.log( `You've been inactive for ${ duration }ms.` );
    } );

    // Fetch and load the initial translations for the site. Because the user is
    // not authenticated yet, and we don't have an access token to retrieve strings
    // from CMX, we have to attempt local translations.
    const translationsRetrieved = await translationService.fetchTranslations( { attemptExternal: false } );
    if ( !translationsRetrieved ) {
        console.error( `No local translations available for default language '${ translationService.localeCode }'.` );
    }

    // ...
}
